import "./App.css";
import {useEffect,useState} from 'react'
import Home from "./components/Home/Home";
import { LoopCircleLoading } from "react-loadingg";

function App() {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  }, []);

  return (
    <div className="App">
      {loading ? (
        <div className="loader">
          {/* <img src={logo} alt=""/> */}
          <LoopCircleLoading
            size={1000}
            speed={1}
            color={"rgba(25, 42, 86, 0.7)"}
            loading={loading}
          />
        </div>
      ) : (
        <Home />
      )}
    </div>
  );
}

export default App;
